module.exports = __webpack_public_path__ + "img/inductrialInjuryPrevention_11.37fbd79d.png";